export default __webpack_public_path__ + "static/media/dashboard-audience.5f7eafca.svg";